/**
 * Main nav interactions from SeventyTwo 2026:
 * - Mobile menu wipe / submenu toggles
 * - Sticky white scroll header (desktop: when top nav leaves; mobile: only while scrolling up)
 */

function initMobileMenu() {
    var mobileMenu = document.getElementById('mobile-menu');
    if (!mobileMenu) {
        return;
    }

    mobileMenu.addEventListener('show.bs.offcanvas', function () {
        mobileMenu.setAttribute('data-menu', 'open');
        document.documentElement.setAttribute('data-menu', 'open');
    });

    mobileMenu.addEventListener('hide.bs.offcanvas', function () {
        mobileMenu.setAttribute('data-menu', 'closed');
        document.documentElement.setAttribute('data-menu', 'closed');
    });

    mobileMenu.addEventListener('click', function (event) {
        var toggle = event.target.closest('[data-mobile-submenu-toggle]');
        if (!toggle || !mobileMenu.contains(toggle)) {
            return;
        }

        event.preventDefault();
        var targetId = toggle.getAttribute('data-bs-target');
        var panel = targetId ? document.querySelector(targetId) : null;
        if (!panel) {
            return;
        }

        var isOpen = panel.hasAttribute('data-open');
        if (isOpen) {
            panel.removeAttribute('data-open');
            panel.setAttribute('inert', '');
            toggle.classList.add('is-collapsed');
            toggle.setAttribute('aria-expanded', 'false');
        } else {
            panel.setAttribute('data-open', '');
            panel.removeAttribute('inert');
            toggle.classList.remove('is-collapsed');
            toggle.setAttribute('aria-expanded', 'true');
        }
    });
}

function initScrollHeader() {
    var scrollHeader = document.getElementById('scroll-header');
    // Artifact observes the nav row (x-ref="nav"), not the whole header block
    var sentinel =
        document.querySelector('[data-nav-sentinel]') ||
        document.getElementById('header');
    if (!scrollHeader || !sentinel) {
        return;
    }

    // Match Bootstrap md — same breakpoint as desktop / mobile nav swap
    var desktopMq = window.matchMedia('(min-width: 768px)');
    var navHidden = false;
    var scrollingUp = false;
    var isDesktop = desktopMq.matches;
    var lastY = window.scrollY;

    function isStuck() {
        return navHidden && (isDesktop || scrollingUp);
    }

    function sync() {
        var stuck = isStuck();
        scrollHeader.dataset.stuck = stuck ? 'true' : 'false';
        scrollHeader.classList.toggle('is-stuck', stuck);

        if (stuck) {
            scrollHeader.removeAttribute('inert');
        } else {
            scrollHeader.setAttribute('inert', '');
        }
    }

    new IntersectionObserver(function (entries) {
        navHidden = !entries[0].isIntersecting;
        sync();
    }).observe(sentinel);

    desktopMq.addEventListener('change', function (event) {
        isDesktop = event.matches;
        sync();
    });

    window.addEventListener(
        'scroll',
        function () {
            var y = window.scrollY;
            if (Math.abs(y - lastY) < 8) {
                return;
            }
            scrollingUp = y < lastY;
            lastY = y;
            sync();
        },
        { passive: true }
    );

    sync();
}

export function initMainNav() {
    initMobileMenu();
    initScrollHeader();
}
